import {Directive, Input, TemplateRef, ViewContainerRef} from '@angular/core';
import {AccessPermissionTypes} from '../access-permission.model';
import {AccessControlService} from '../services/access-control.service';

@Directive({
  selector: '[appDeleteAccessControl]'
})
export class DeleteAccessControlDirective {

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainerRef: ViewContainerRef,
    private accessControlService: AccessControlService
  ) {
  }

  @Input() set appDeleteAccessControl(componentName: string) {
    if (componentName) {
      const permission = this.getPermissions(componentName, 'delete');
      if (permission) {
        this.viewContainerRef.createEmbeddedView(this.templateRef);
      } else {
        this.viewContainerRef.clear();
      }
    } else {
      this.viewContainerRef.createEmbeddedView(this.templateRef);
    }
  }

  private getPermissions(componentOrAction: string, accessType: AccessPermissionTypes) {
    const activeModule = this.accessControlService.activeModule;
    return this.accessControlService.getAccessPermissions(activeModule, componentOrAction, accessType);
  }
}
